//#region react/redux
import React, { Component } from "react"
import { connect } from "react-redux"
import { bindActionCreators } from 'redux'
//#endregion react/redux

//#region modules
import { actions as advisersActions } from '../../modules/advisersModule'
import { actions as appActions } from '../../modules/appModule'
import { actions as commonActions } from '../../modules/commonModule'
import { actions as favActions } from '../../modules/favouritesModule'
import { actions as lseActions } from "../../modules/lseModule"
import { actions as nexusActions } from "../../modules/nexusModule"
import { actions as newsActions } from "../../modules/newsModule"
import { actions as searchActions } from '../../modules/searchModule'
import { actions as synopsisActions } from '../../modules/synopsisModule'
//#endregion modules

import Scrollbars from "react-custom-scrollbars-2"
import { Box, Tooltip } from "@mui/material"
import Typography from "@mui/material/Typography"

import Footer from "../../components/Footer"
import Navbar from "../../components/layout/DashboardNavbar"
import HomePageTabs from "../../components/HomePageTabs"
import SubscriptionFeatureModal from "../../components/SubscriptionFeatureModal"

import { formatDate_toLocal } from "../../modules/utilities"
import { BASE, CONSTANTS, PATH } from "../../modules/constants"
import { COLOR } from "../../utils/colorsAndFilters"
import { LoadFavouritesAndLSEs } from "../companiesHouse/pageFunctions/loadFavouritesAndLSEs"
import { getTabIndex } from "../companiesHouse/pageFunctions/homeFunctions"
import { analyseUrl, findKind, getKind, newUrl } from "../companiesHouse/pageFunctions/commonFunctions"

import { withStyles } from "@mui/styles"
import { Divider } from "@mui/material"
import CircularProgress from '@mui/material/CircularProgress'

const styles = theme => ({
  row: {
    display: "flex",
    // flexWrap: "wrap",
    // flexDirection: "row",
    justifyContent: "center",
    // width: "100%",
  },
  column: {
    display: "flex",
    flexDirection: "column",
    flexBasis: "100%",
    flex: 1,
    paddingLeft: 10,
    paddingRight: 10,
  },
  nextRelease: {
    width: 400,
    marginLeft: "auto",
    marginRight: "auto",
  },
  html: {
    width: 835,
    marginLeft: "auto",
    marginRight: "auto"
  },
  horizontalLine: {
    display: "block",
  },
})

class newsRelease extends Component {

  //#region constructor
  constructor(props) {
    // console.log(" newsRelease constructor: props: ", props)
    super()

    const tabIndex = getTabIndex(props.location.pathname)

    if (props.tabIndex !== tabIndex)
      props.common.setTabIndex(tabIndex)

    this.state = {
    }

    this.handleKeyPress = this.handleKeyPress.bind(this);
  }
  //#endregion constructor

  componentDidMount() {
    // console.log("newsRelease componentDidMount() this.props: ", this.props)
    // https://forum.freecodecamp.org/t/using-this-in-event-listeners/509217
    document.addEventListener('click', this.handleKeyPress)
    this.urlAndPropsSynced()
    LoadFavouritesAndLSEs(this.props)
  }
  componentWillUnmount() {
    document.removeEventListener('click', this.handleKeyPress)
  }

  componentDidUpdate(prevProps, prevState) {
    // console.log("componentDidUpdate() this.props: ", this.props)
    this.urlAndPropsSynced()

    // Ensure favourites and LSEs are loaded and synced
    LoadFavouritesAndLSEs(this.props)

    // Ensure news html is loaded and correct
    const id = this.props.match.params.newsId
    if (this.props.newsRelease?._id !== null && this.props.newsRelease?._id !== id)
      this.props.news.getRelease({ id })
  }

  urlAndPropsSynced = () => {
    // If the url does not match the props, save new props to common state - driving update
    const urlProps = analyseUrl(this.props)

    if (newUrl(this.props, urlProps)) // has the url changed?
      this.props.common.saveSettings({ ...this.props, ...urlProps })
  }

  handleKeyPress = event => {
    if (event.target.id == 'personId') {
      const pathname = `/person/${event.target.attributes.personId.value}`
      this.props.common.selectRow({ ...this.props, pathname })
    } else
      if (event.target.id == 'companyNumber') {
        const pathname = `/company/${event.target.attributes.companyNumber.value}`
        this.props.common.selectRow({ ...this.props, pathname })
      }
  }

  render() {
    // console.log(`this.props: `, this.props)
    const { classes, features, newsRelease, portrait, radio, regeneratingSummary, tabIndex } = this.props
    // console.log('getKind(tabIndex, radio):', findKind(getKind(tabIndex, radio)))

    const handleSelect = hit => {
      // console.log('hit:',hit)
      var pathname = `/${PATH[BASE.COMPANY]}/${hit.number}`

      // Don't go to company tab if not premium user
      if (!features.MaxLseData) {
        this.props.common.setLoginUrl({ pathname })
        this.setState({ showSubscriptionFeatureModal: true })
      }
      else
        this.props.common.selectRow({ ...this.props, pathname })
    }

    return (
      <React.Fragment>
        <Navbar
          title={"Numerable"}
          state={this.state}
          portrait={portrait}
        />

        {/* tabs bar */}
        {newsRelease && <HomePageTabs />}

        {/* main content area — flex:1 ensures tabs bar is not clipped */}
        <Box style={{ flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column' }}>
          {newsRelease && newsRelease._id && <React.Fragment>
            <Box className={classes.row}>

              {/* If dev, show original inner html */}
              <Box className={classes.column}>

                {/* If dev and const set, show original html */}
                {features.Developer && CONSTANTS.SHOW_ORIGINAL_NEWS_HTML && <Box className={classes.nextRelease}>
                </Box>}

                <Tooltip title={`view ${newsRelease.company}`}>
                  <Box className={classes.column} style={{ cursor: "pointer" }} onClick={() => handleSelect(newsRelease)} >
                    {newsRelease.logo &&
                      <img
                        alt="company logo"
                        src={newsRelease.logo}
                        style={{ maxWidth: 140, maxHeight: 60, marginLeft: "auto", marginRight: "auto", marginTop: 10 }}
                      />
                    }

                    <Typography align="center" style={{ marginTop: 18, fontSize: 14 }}>
                      Published by {newsRelease.company} on {formatDate_toLocal(newsRelease.publicationDate)}
                    </Typography>

                    <Typography align="center" style={{ fontSize: 24 }}>
                      {newsRelease.headline}
                    </Typography>
                  </Box>
                </Tooltip>

                <Divider />
              </Box>
            </Box>

            {newsRelease.summary &&
              <Box className={classes.row}>
                <Box className={classes.html} style={{ backgroundColor: COLOR.BRAND.LIGHT, borderRadius: 4, padding: '8px 16px', marginTop: 12 }}>
                  {features.Developer
                    ? <Tooltip title="Regenerate this release's AI summary - eg after changing the summarising prompt. This calls Gemini again and incurs a cost.">
                        <Typography
                          style={{
                            alignItems: "center",
                            cursor: regeneratingSummary ? "default" : "pointer",
                            display: "inline-flex",
                            fontWeight: "bold",
                            gap: 8,
                            opacity: regeneratingSummary ? 0.5 : 1,
                          }}
                          onClick={() => !regeneratingSummary && this.props.news.regenerateSummary({ id: newsRelease._id })}
                        >
                          AI Summary
                          {regeneratingSummary && <CircularProgress size={14} />}
                        </Typography>
                      </Tooltip>
                    : <Typography style={{ fontWeight: "bold" }}>AI Summary</Typography>
                  }
                  <Typography>{newsRelease.summary}</Typography>
                </Box>
              </Box>
            }

            <Scrollbars id="scrollbars" style={{ flex: 1 }}>
              <Box className={classes.row}>
                {/* If dev and landscape and have innerHtml, show original inner html */}
                {features.Developer && CONSTANTS.SHOW_ORIGINAL_NEWS_HTML && !portrait && newsRelease?.originalInnerHtml &&
                  <Box className={classes.column} style={{ paddingRight: 15 }}>
                    <Box className={classes.html}
                      id="html"
                      dangerouslySetInnerHTML={{ __html: newsRelease?.originalInnerHtml }}
                      style={{ zoom: portrait ? 0.55 : 1 }}
                    />
                  </Box>
                }

                <Box className={classes.column} style={{ paddingRight: 15 }}>
                  <Box className={classes.html}
                    id="html"
                    dangerouslySetInnerHTML={{ __html: newsRelease?.innerHtml }}
                    style={{ zoom: portrait ? 0.55 : 1 }}
                  />
                </Box>
              </Box>
            </Scrollbars>
          </React.Fragment>}

          {/* Show spinner during import of html i.e. while newsRelease._id is null */}
          {newsRelease && !newsRelease._id && <CircularProgress
            style={{ position: "fixed", top: "calc(50% - 20px)", left: "calc(50% - 20px)", zIndex: 2 }}
          />}
        </Box>

        {newsRelease && <Footer urlSource={this.props.urlSource} />}

        <SubscriptionFeatureModal
          open={this.state.showSubscriptionFeatureModal}
          onClose={() => { this.setState({ showSubscriptionFeatureModal: false }) }}
        />

      </React.Fragment>
    )
  }
}

const mapDispatchToProps = dispatch => {
  return {
    advisers: bindActionCreators(advisersActions, dispatch),
    app: bindActionCreators(appActions, dispatch),
    common: bindActionCreators(commonActions, dispatch),
    fav: bindActionCreators(favActions, dispatch),
    lse: bindActionCreators(lseActions, dispatch),
    news: bindActionCreators(newsActions, dispatch),
    nexus: bindActionCreators(nexusActions, dispatch),
    search: bindActionCreators(searchActions, dispatch),
    synopsis: bindActionCreators(synopsisActions, dispatch),
  }
}

const mapStateToProps = ({ app, common, lse, news, user }) => {
  return {
    // app
    features: app.features,

    // common
    checkboxes: common.checkboxes,
    companyId: common.companyId,
    currentUrl: common.currentUrl,
    newsId: common.newsId,
    nexusView: common.nexusView,
    personId: common.personId,
    radio: common.radio,
    searchStringObj: common.searchStringObj,
    tabIndex: common.tabIndex,
    urlSource: common.urlSource,

    // lse
    lseCompaniesMeta: lse.companiesMeta,
    lseApptsMeta: lse.apptsMeta,
    lsePeopleMeta: lse.peopleMeta,

    // news
    newsRelease: news.release,
    newsMeta: news.meta,
    regeneratingSummary: news.regeneratingSummary,

    // user
    portrait: user.portrait,
  }
}

// @ts-ignore
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(newsRelease))
